import React from 'react';
import {
  ConnectionProfile,
  ProjectStatus,
  ProjectType,
  useFubStagesService,
  useFubStatusMapService
} from 'nekst-api';
import {
  AfterSubmitFunc,
  Dropdown,
  FormTemplate,
  LoadingAnimation,
  useShowContextRequired
} from 'ui-builder';
import { ProjectStatusDropdown, ProjectTypeDropdown } from 'features/tasks-forms';
import { useDataLoaderNew } from 'data-loader';

function FubStageDropdown(props: {
  profile: ConnectionProfile,
  projectType: ProjectType,
}) {
  const fubStagesService = useFubStagesService();

  const { data: stages } = useDataLoaderNew(
    async () => fubStagesService.getAllStages(props.profile.id, props.projectType),
  );

  if (stages) {
    return (
      <Dropdown
        options={stages.map((item) => ({
          label: item.name,
          value: item.id,
        }))}
        source="stageId"
        label="Follow Up Boss Stage"
      />
    );
  } else {
    return (<LoadingAnimation />);
  }
}

export function UpdateStageToStatusEntryForm(
  props: {
    profile: ConnectionProfile,
    projectType: ProjectType,
    projectStatus: ProjectStatus,
    initialStageId?: number,
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const fubStatusMapService = useFubStatusMapService();

  const showContext = useShowContextRequired();

  return (
    <FormTemplate<{ stageId: number, projectType: ProjectType, projectStatus: ProjectStatus }>
      title="Update Stage to Status"
      submitFormFunc={async (data) => {
        await fubStatusMapService.updateMapEntry(
          props.profile.id,
          props.projectType,
          props.projectStatus,
          {
            fubStageId: data.stageId
          }
        );

        return data;
      }}
      initialData={{
        projectType: props.projectType,
        projectStatus: props.projectStatus,
        stageId: showContext.data.stageId,
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <ProjectTypeDropdown source="projectType" isDisabled label="Trasnaction Type" />
      <ProjectStatusDropdown source="projectStatus" isDisabled label="Transaction Status" />
      <FubStageDropdown profile={props.profile} projectType={props.projectType} />
    </FormTemplate>
  );
}
